import React, { useState, useEffect } from "react";
import TitleUnderlined from "../components/TitleUnderlined";
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import Utils from "../tools/Utils";
import Order from "../models/Order";
import { RoutesWeb } from "../tools/RoutesWeb";
import Breadcrumb from "../components/Breadcrumb";
import APIInterface from "../tools/APIInterface";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import OrderStatus from "../models/OrderStats";
// import CloudError from "../tools/ClourError";
require('../style/views/paymentView.scss');


const PaymentView = () => {
    const { obj } = useParams();
    const [order, setOrder] = useState(Order.fromJson(JSON.parse(Utils.decodeBase64(obj))));
    const [ErrorMessage, setErrorMessage] = useState("");
    const [orderID, setOrderID] = useState(false);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate()

    // creates a paypal order
    const createOrder = (data, actions) => {
        return actions.order.create({
            purchase_units: [
                {
                    description: "Evento",
                    amount: {
                        value: order.total,
                    },
                },
            ],
        }).then((orderID) => {
                setOrderID(orderID);
                return orderID;
            });
    };

    // check Approval
    const onApprove = (data, actions) => {
        let prevOrder = order;
        prevOrder.paypalId = orderID;
        return APIInterface.createOrderPaypal(prevOrder)
        .then((response) => {
            console.log(response);
            if(response.status === 200){
                let newOrder = Order.fromJson(response.data);
                if(newOrder.status === OrderStatus.IN_PROCESS){
                    // We make the payment
                    actions.order.capture().then(function (details) {
                        const { payer } = details;
                        // console.log("PAYER: ", payer);
                        // console.log("DETAIL: ", details);
                        if(details.status === 'COMPLETED') {
                            newOrder.status = OrderStatus.PAID;
                            newOrder.paypalId = details.id;
                            newOrder.paypalStatus = details.status;
                            APIInterface.updateOrderPaypal(newOrder)
                            .then((response) => {
                                let tmp = Order.fromJson(response.data);
                                setOrder(tmp);
                                setSuccess(true);
                            })
                            .catch((error) => {
                                console.error(error);
                                Utils.Toast.fire("Ups", 'Ocurrió un error', 'error');
                            })
                        }           
                    })
                    .catch((error) => {
                        console.log(error);
                        Utils.Toast.fire("Ups", 'Ocurrió un error capturing', 'error');
                    });
                }
            }
        })
        .catch((error) => {
            Utils.Toast.fire("Ups", 'Ocurrió un error', 'error');
            // CloudError.error(error);
        });
    };

    //capture likely error
    const onError = (data, actions) => {
        setErrorMessage("An Error occured with your payment ");
        console.error(ErrorMessage);
    };

    useEffect(() => {
        if (success) {
            // console.log("ORDER TO PASS: ", order);
            navigate(`/gracias/${Utils.encodeBase64(JSON.stringify(order))}`);
        }
    },[success, order, navigate]);

    return (
        <div className="pt-5 pb-5" id="paymentView">
            <br></br>
            <br></br>
            <Breadcrumb items={[
                {
                    title: 'Eventos',
                    route: RoutesWeb.HOME
                },
                {
                    title: 'Detalles del evento',
                    route: RoutesWeb.DETAILS
                },
                {
                    title: 'Boletos',
                    route: `/detalles/tickets/${obj}`
                },
                {
                    title: 'Pago',
                    active: true
                }
            ]} />
            <TitleUnderlined>Completar donativo con <span className="embercom_overlined">Paypal</span></TitleUnderlined>
            <br></br>
            <br></br>
            <br></br>
            <h4 className="text-uppercase"><b>Cuota de recuperación: <span style={{fontSize: '2.6rem', color: '#07068E', fontWeight: 'bold'}}>$ {order.total.toLocaleString('en-US')} MXN</span></b></h4>
            <br></br>
            <p>Una vez completada la operación, recibirá un correo con sus boletos en el mail principal que indicó en el registro.</p>
            <br></br>
            <PayPalScriptProvider options={{"client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, "currency": "MXN", "disable-funding": "card"}} onError={onError}>
                <PayPalButtons
                    style={{ layout: "vertical" }}
                    createOrder={createOrder}
                    onApprove={onApprove}
                />
            </PayPalScriptProvider>
        </div>
    );
}

export default PaymentView;